import * as React from 'react'
import Tippy from '@tippy.js/react'

import { ToolTipWrapper } from '../components/BrandDashboard/components/BrandOrderListNew/BrandOrderListNew.style'
import { LocationTag } from '../components/BrandDashboard/components/BrandOrderCardNew/BrandOrderCardNew.style'

interface Location {
  address: string
  cityId: string
  cityName: string
  citySubdivisionCode: string
  citySubdivisionName: string
  countryCode: string
  countryGroup: string
  countryId: string
  countryName: string
  lat: number
  long: number
}

export const locationsHelper = (locations: Location[] | null) => {
  const locationsTooltip =
    locations &&
    locations.map(location => (
      <span key={location.cityId}>
        {location.cityName}, {location.countryName} <br />
      </span>
    ))
  if (!locations) {
    return <div>-</div>
  }
  if (locations.length > 1) {
    return (
      <Tippy
        content={<ToolTipWrapper>{locationsTooltip}</ToolTipWrapper>}
        animation="fade"
        placement="top-end"
      >
        <span>{locations.length} locations</span>
      </Tippy>
    )
  }
  return locations.map(location => `${location.cityName}, ${location.countryName}`).join(', ')
}

export const cardLocationsHelper = (locations: Location[] | null) => {
  const locationsTooltip =
    locations &&
    locations.map(location => (
      <span key={location.cityId}>
        {location.cityName}, {location.countryName} <br />
      </span>
    ))
  if (!locations) {
    return <div style={{ height: '2.25rem' }} />
  }
  if (locations.length > 1) {
    return (
      <Tippy
        content={<ToolTipWrapper>{locationsTooltip}</ToolTipWrapper>}
        animation="fade"
        placement="top-end"
      >
        <LocationTag>{`${locations.length} LOCATIONS`}</LocationTag>
      </Tippy>
    )
  }
  return (
    <LocationTag>
      {locations && locations[0].countryName},{` `}
      {locations && locations[0].cityName}
    </LocationTag>
  )
}



// WEBPACK FOOTER //
// ./src/helpers/locationHelpers.tsx